import CONST from './Constant';
import axiosPrivate from '../../../../Setup/Axios/SetupAxios';
import { handleAsyncAction } from "../../../../Setup";

export const setConfig = (payload) => ({
    type: CONST.SET_CONFIG,
    payload,
});

export const setSelectedThemes = (payload) => ({
    type: CONST.SET_SELECTED_ITEM,
    payload: payload
});

export const setPreviewTheme = (payload) => ({
    type: CONST.SET_PREVIEW_THEME,
    payload: payload
});

export const setActiveTheme = (payload) => ({
    type: CONST.SET_ACTIVE_THEME,
    payload: payload
});

export const clearPreview = () => ({
    type: CONST.CLEAR_PREVIEW,
});

/*****************************************************
 * Fetch Theme
 ****************************************************/
export const fetchThemeSuccess = (payload) => ({
    type: CONST.FETCH_ITEM_SUCCESS,
    payload: payload
});

export const fetchThemeFailed = (payload) => ({
    type: CONST.FETCH_ITEM_FAILED,
    payload: payload
});

export const fetchTheme = ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get(`core/themes/${filters['id']}`, {params: filters}),
        [fetchThemeSuccess],
        [fetchThemeFailed]
    );
};

/*****************************************************
 * Fetch Themes
 ****************************************************/
export const fetchThemesSuccess = (payload) => ({
    type: CONST.FETCH_ITEMS_SUCCESS,
    payload: payload
});

export const fetchThemesFailed = (payload) => ({
    type: CONST.FETCH_ITEMS_FAILED,
    payload: payload
});

export const fetchThemes = ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get('core/themes', { params: filters }),
        [fetchThemesSuccess],
        [fetchThemesFailed]
    );
};

/*****************************************************
 * Add Themes
 ****************************************************/
export const addThemesSuccess = (payload) => ({
    type: CONST.ADD_ITEM_SUCCESS,
    payload: payload
});

export const addThemesFailed = (payload) => ({
    type: CONST.ADD_ITEM_FAILED,
    payload: payload
});

export const addThemes = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('core/themes', data),
        [addThemesSuccess],
        [addThemesFailed]
    );
};

/*****************************************************
 * Update Themes
 ****************************************************/
export const updateThemesSuccess = (payload) => ({
    type: CONST.UPDATE_ITEM_SUCCESS,
    payload: payload
});

export const updateThemesFailed = (payload) => ({
    type: CONST.UPDATE_ITEM_FAILED,
    payload: payload
});

export const updateThemes = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.patch(`core/themes/${data['id']}`, data),
        [updateThemesSuccess],
        [updateThemesFailed]
    );
};

/*****************************************************
 * Delete Themes
 ****************************************************/
export const deleteThemesSuccess = (payload) => ({
    type: CONST.DELETE_ITEM_SUCCESS,
    payload: payload
});

export const deleteThemesFailed = (payload) => ({
    type: CONST.DELETE_ITEM_FAILED,
    payload: payload
});

export const deleteThemes = ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.delete(`core/themes/${filters['id']}`),
        [deleteThemesSuccess],
        [deleteThemesFailed]
    );
};